import React from 'react';
import { Tooltip, Button } from 'antd';

const Btn = ({ onClick, loading, tooltipTitle, style = {}, ...props }) => {
  const btn = (
    <Button
      type="primary"
      shape="circle"
      icon={loading ? 'loading' : 'printer'}
      style={{ fontSize: '16px', ...style }}
      onClick={onClick}
      {...props}
    />
  );

  return tooltipTitle ? (
    <Tooltip
      title={tooltipTitle}
      placement="bottom"
    >
      {btn}
    </Tooltip>
  ) : (
    btn
  );
};

export default Btn;
